import { render, staticRenderFns } from "./GupshupWhatsapp.vue?vue&type=template&id=589b1bdc&"
import script from "./GupshupWhatsapp.vue?vue&type=script&lang=js&"
export * from "./GupshupWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports